import { ms2laptime } from './Time'

/**
 * Room in pixels for the laptimes left of a chart's plot. Google Charts writes them in 11px Arial,
 * the widest about 43px, and centres them in this room with at most 11px to the plot; 60 leaves
 * about 8px on both sides
 * @type {number}
 */
export const LAPTIME_AXIS_WIDTH = 60

/**
 * Room above the slowest and below the fastest laptime, as part of the range, so their gridlines
 * and labels stay inside the plot
 * @type {number}
 */
const LAPTIME_PADDING = 0.06

/**
 * Get the vertical laptime axis of a chart: labels at the fastest, average and slowest laptime,
 * with some room above and below
 * @param {Array<number>} values laptimes in ms
 * @returns {{ ticks: Array<{ v: number, f: string }>, viewWindow: { min: number, max: number } }} vAxis options
 */
export const getLaptimeAxis = ( values ) =>
{
  const min = Math.min( ...values )
  const max = Math.max( ...values )
  const average = values.reduce( ( total, value ) => total + value, 0 ) / values.length
  const padding = ( max - min ) * LAPTIME_PADDING || 1000

  return {
    ticks: [ min, average, max ].map( v => ( { v, f: ms2laptime( Math.round( v ) ) } ) ),
    viewWindow: { min: min - padding, max: max + padding }
  }
}
